module.exports = __webpack_public_path__ + "media/images/question_bank_header-255eb5ffe3e54a77f94f84856024a919.png";